import React, { useCallback, useState } from "react";
import { Alert, Box, Button } from "@mui/material";
import { useTranslation } from "react-i18next";
import {
  isAndroidUa,
  isIosUa,
  resolveWebchatBrowserOpenUrl,
} from "./webchatStandalone";

export default function WebchatPwaEscapeBanner() {
  const { t } = useTranslation("chat");
  const [copied, setCopied] = useState(false);
  const href = typeof window !== "undefined" ? window.location.href : "";
  const android = isAndroidUa();
  const ios = isIosUa();
  const browserHref = resolveWebchatBrowserOpenUrl(href);

  const openInBrowser = useCallback(() => {
    if (!href) return;
    const opened = window.open(href, "_blank", "noopener,noreferrer");
    if (!opened && browserHref && browserHref !== href) {
      window.location.href = browserHref;
    }
  }, [browserHref, href]);

  const copyLink = useCallback(async () => {
    try {
      await navigator.clipboard.writeText(href);
      setCopied(true);
    } catch {
      setCopied(false);
    }
  }, [href]);

  return (
    <Alert
      severity="info"
      sx={{
        borderRadius: 0,
        py: 0.5,
        px: 1.25,
        "& .MuiAlert-message": { width: "100%", py: 0.25 },
      }}
    >
      <Box sx={{ fontSize: "0.78rem", lineHeight: 1.35, color: "text.primary" }}>
        {t(
          "webchat.pwaEscapeBody",
          "Este link abriu no app Xpro. O Web Chat do cliente precisa do navegador."
        )}{" "}
        {ios
          ? t(
              "webchat.pwaEscapeIos",
              "No iPhone, toque em Compartilhar e escolha Abrir no Safari."
            )
          : null}
      </Box>
      <Box sx={{ display: "flex", gap: 0.75, mt: 0.5, flexWrap: "wrap" }}>
        {android ? (
          <Button
            size="small"
            variant="contained"
            component="a"
            href={browserHref || href}
            sx={{ textTransform: "none" }}
          >
            {t("webchat.pwaEscapeOpen", "Abrir no navegador")}
          </Button>
        ) : (
          <Button size="small" variant="contained" onClick={openInBrowser} sx={{ textTransform: "none" }}>
            {t("webchat.pwaEscapeOpen", "Abrir no navegador")}
          </Button>
        )}
        <Button size="small" variant="text" onClick={copyLink} sx={{ textTransform: "none" }}>
          {copied
            ? t("webchat.pwaEscapeCopied", "Link copiado")
            : t("webchat.pwaEscapeCopy", "Copiar link")}
        </Button>
      </Box>
    </Alert>
  );
}
